import React from 'react';
import privacyPolicyBlocks from '../content/privacyPolicyBlocks';
import LegalTextPage from './LegalTextPage';

const PrivacyPolicy = () => {
  return <LegalTextPage title="Privacy Policy" blocks={privacyPolicyBlocks} />;
};

export default PrivacyPolicy;
